import './scss/index.scss';
import 'owl.carousel';
import { dcFactory } from 'dc';
import TextImageCarouselComponent from './js/text-carousel.component';

dcFactory.register(TextImageCarouselComponent);
